import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./styles/bootstrap-reboot.min.css";
import "./styles/bootstrap.min.css";
import "./styles/app.css";
ReactDOM.render(<App />, document.getElementById("root"));
